import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import React, { useEffect, useState } from "react";
import { getValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import Notfound from "@components/Not-Found";
import Loader from "@components/common/Loader";
import { useParams } from "react-router-dom";
import { formatText } from "@_common/format-text";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import { NavLink } from "react-router-dom";
import {
  NewDate,
  convertCurrentDate,
  convertCurrentDateWithTime,
  convertDate,
} from "@_common/date-helpers";
import {
  UpdateMultipleSelfComplianceTask,
  UpdateSelfComplianceTask,
  getSpecificSelfComplianceTask,
  getSpecificSelfComplianceTaskHistory,
} from "@services/self-compliance.service";
import SelfComplianceTaskNavigation from "@components/Tasks/task-self-compliance-navigation";
import NavigationBar from "@components/NotificationBar";
import { clientAdminFileUpload } from "@services/client-list.service";
import { toast } from "react-toastify";
import InputField from "@_common/InputRuleFeild";
import DragAndDropFileComponent from "@_common/file-drag-drop";
// import UpdateTaskPopup from "../UpdateTaskPopup";
import { tableStatusStyle } from "@_common/colors";
import { getEntityGroups } from "@services/entity-mapping.service";
// import SelfComplianceUpdatePopup from "../UpdateTaskPopup";
import { Button } from "reactstrap";
import MappedCheckpointMasterTaskHistoryNotfound from "@components/Page-Not-Found/mappedc-task-history-not-found";
import { getSpecificCategoryLawById } from "@_common/global-apis";
import {
  getSpecificLegacyTask,
  getSpecificLegalTaskTaskHistory,
} from "@services/email-template.service";
import LegacyTaskNavigation from "../TaskNavigationComponent/task-self-compliance-navigation";
import LegacyTaskEditTask from "../../TaskDetailsComponent/edit-task";

// interface IComplianceTaskHistoryProps {}
export default function LegacyTaskHistoryPage(props: any) {
  // const LegacyTaskHistoryPage: React.FunctionComponent<IComplianceTaskHistoryProps> = (
  //   props: any
  // ) =>
  let navigate = useNavigate();
  let mainParams = useParams();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [userInfo, setUserInfo] = useState({});

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
    }
    let userInfo = getValue(localStorage, `user`, {});
    let user = JSON.parse(userInfo);
    if (getValue(user, `id`, "")) {
      setUserInfo(user);
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text_main) {
        setSearchInput(params.search_text_main);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);


  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [licenseIDs, setLicenseIDs] = useState([]);
  const [data, setData] = useState({});
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    // let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    // let dates = params.date ? new Date(params.date) : new Date();
    // var from_date = params.from_date
    // 	? params.from_date
    // 	: new Date(dates.getFullYear(), dates.getMonth(), 1);
    // var to_date = params.to_date
    // 	? params.to_date
    // 	: new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    //entity mapping
    let obj: any = {};
    // let response = await getEntityGroups("");
    let resp = await getSpecificLegacyTask(mainParams.id);
    const decodeUnit = (unit:any) => unit.replace(/%20/g, ' ');

    const newObject: any = {
      // level_1: getValue(resp, `data.self_compliance.level_1.id`, ""),
      // level_2: getValue(resp, `data.self_compliance.level_2.id`, ""),
      // level_3: getValue(resp, `data.self_compliance.level_3.id`, ""),
      // level_4: getValue(resp, `data.self_compliance.level_4.id`, ""),
      // level_5: getValue(resp, `data.self_compliance.level_5.id`, ""),
      // level_6: getValue(resp, `data.self_compliance.level_6.id`, ""),
      // level_7: getValue(resp, `data.self_compliance.level_7.id`, ""),
      // level_8: getValue(resp, `data.self_compliance.level_8.id`, ""),
      // level_9: getValue(resp, `data.self_compliance.level_9.id`, ""),
      // level_10: getValue(resp, `data.self_compliance.level_10.id`, ""),
      // Add more levels as needed
      unit: getValue(resp, `data.unit`, ``),
      function: decodeURIComponent(getValue(resp, `data.function`, "")),
      entity: decodeURIComponent(getValue(resp, `data.entity`, "")),
      lexcare_task_id: getValue(resp,`data.lexcare_task_id`, ""),
    };
    Object.keys(newObject).forEach((key) => {
      if (!newObject[key] || newObject[key] === undefined) {
        delete newObject[key];
      }
    });
    // if (response) {
    // 	console.log(response)
    // 	getValue(response, `data.entityGroups`, []).map((item: any) => {
    // 		return (obj[`level_${getValue(item, `group_level`, "")}`] = getValue(
    // 			item,
    // 			`id`,
    // 			""
    // 		));
    // 	});
    // }

    let payload: any = {
      // from_date: convertDate(from_date),
      // to_date: convertDate(to_date),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text_main,
      lexcare_task_id: mainParams.lexcare_task_id,
      sort_by: params.sort_by,
      country_id: parseInt(getValue(params, `country_id`, "")),
      state_id: parseInt(getValue(params, `state_id`, "")),
      category_of_law_id: await getSpecificCategoryLawById(
        getValue(params, `category_of_law_id`, "")
      ),
      legislation_id: getValue(params, `legislation_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      event_id: parseInt(getValue(params, `event_id`, "")),
      sub_event_id: parseInt(getValue(params, `sub_event_id`, "")),
      compliance_type_id: getValue(params, `compliance_type_id`, ""),
      // request_from: "MY_TASKS",
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    //finding only levels params if it presented in URL
    let queryRequest =  QueryRequestHelper({ ...payload, ...newObject });
    try {
      setIsLoading(true);
      let resp = await getSpecificLegalTaskTaskHistory(
        mainParams.id,
        { ...payload, ...newObject }
      );

      let response = await getSpecificLegacyTask(mainParams.id);
      if (response) {
        setData(getValue(response, `data`, {}));
      }

      if (resp) {
        setList(
          getValue(resp, `data.task_history`, []).map((item: object) => ({
            ...item,
            created_at: convertCurrentDateWithTime(
              getValue(item, `created_at`, "")
            ),
            executor_date: convertCurrentDateWithTime(
              getValue(item, `executorDate`, "")
            ),
            evaluator_date: convertCurrentDateWithTime(
              getValue(item, `evaluator_date`, "")
            ),
            func_head_date: convertCurrentDateWithTime(
              getValue(item, `function_head_date`, "")
            ),
            legal_due_date: convertCurrentDateWithTime(
              getValue(item, `legal_due_date`, "")
            ),
            status:getValue(item, `status`, ""),
          }))
        );
        let licenseIDs = getValue(resp, `data.checkpoints`, []).filter(
          (item: object) =>
            getValue(item, `compliance_type.text`, "") === "License"
        );
        setLicenseIDs(
          getValue(licenseIDs, `length`, 0) > 0
            ? licenseIDs.map((item: any) => item.id)
            : []
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text_main) {
      delete params.search_text_main;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    setSearchInput(e.target.value);
    let payload: any = {
      ...params,
      page_no: 1,
      search_text_main: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const [selectedId, setSelectedId] = useState("");
  const rowClick = (obj: object) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(
      `/${route[1]}/${route[2]}/${route[3]}/task-details/${getValue(
        obj,
        `original.ttrn_id`,
        ""
      )}/${getValue(
        obj,
        `original.client_task_id`,
        ""
      )}?${queryRequest}`
    );
  };

  function formatStatus(status:any) {
    return status.toUpperCase().replace(/ /g, "_");
  }


  const handleClickPopup = (obj: object) => {
    setShowUpdatePopup(!showUpdatePopup);
    setSelectedId(getValue(obj, `original.id`, ""));
    setSelfCompliance({
      ...selfCompliance,
      status: formatStatus(getValue(obj, `status`, "" )),
      remark: getValue(obj, `remark`, ""),
      document_ids: getValue(obj, `documents`, []),
    });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Lexcare Task ID",
        accessor: "lexcare_task_id",
        width: 150,
        Cell: ({ row }: any) => {
          return (
            <NavLink to={`#`}>{getValue(row, `original.lexcare_task_id`, "")}</NavLink>
          );
        },
      },
      
      {
        Header: "Executor Name",
        accessor: "executor",
        width: 150,
      },
      {
        Header: "Executor Date",
        accessor: "executor_date",
        width: 120,
      },
      {
        Header: "Evaluator Date",
        accessor: "evaluator_date",
        width: 120,
      },
      {
        Header: "Function Head Date",
        accessor: "func_head_date",
        width: 150,
      },
      {
        Header: "Legal Due Date",
        accessor: "legal_due_date",
        width: 120,
      },
      {
        Header: "Status",
        accessor: "status",
        width: 120,
      },
      {
        Header: "Created Date",
        accessor: "created_at",
        width: 150,
      },
    ],
    []
  );
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: tableStatusStyle(getValue(rowInfo, `compliance_status`, "")),
      };
    }
    return {};
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const getSpecificPermissions = (permission: string) => {
    switch (permission) {
      case "my-task":
        return "activities_self_compliance_executor_task";
      case "pending-approval":
        return "activities_self_compliance_evaluator_approval";
      case "approved-task":
        return "activities_self_compliance_completed_task";
      case "master":
        return "repository_mapped_checkpoint_master";
      case "function-head":
        return "repository_mapped_checkpoint_function_head";
      case "evaluator":
        return "repository_mapped_checkpoint_evaluator";
      case "pending-audit":
        return "audit_compliance_audit_pending";
      case "completed-audit":
        return "audit_compliance_audit_completed";
      default:
        return null;
    }
  };
  let route = window.location.pathname.split("/");
  /* ---------------------------  Update Modal  ----------------------------- */

  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  const [selectedObj, setSelectedObj] = useState({});
  const handleUpdateTask = () => {
    setShowUpdatePopup(!showUpdatePopup);
    if (getValue(selectedIDs, `length`, 0) === 1) {
      let findOne =
        getValue(list, `length`, 0) > 0
          ? list.filter(
              (item) =>
                getValue(item, `id`, "") === getValue(selectedIDs, `[${0}]`, "")
            )
          : [];
      setSelectedObj(getValue(findOne, `[${0}]`, {}));
      // if (getValue(findOne, `length`, 0) > 0) {
      setSelfCompliance({
        ...selfCompliance,
        completion_date: getValue(findOne, `[${0}].completion_date`, null)
          ? NewDate(getValue(findOne, `[${0}].completion_date`, null))
          : new Date(),
        compliance_status: getValue(findOne, `[${0}].compliance_status`, null),
        work_status: getValue(findOne, `[${0}].work_status`, null),
        remarks: getValue(findOne, `[${0}].remarks`, null),
        non_compliance_reason: getValue(
          findOne,
          `[${0}].non_compliance_reason`,
          null
        ),
        event_not_occured: getValue(findOne, `[${0}].event_not_occured`, false),
        document_ids: getValue(findOne, `[${0}].documents`, []),
        evaluator_comments: getValue(
          findOne,
          `[${0}].evaluator_comments`,
          null
        ),
      });
      setUpdateId(getValue(findOne, `[${0}].self_compliance.id`, null));
      // }
    } else {
      setSelfCompliance({
        ...selfCompliance,
        completion_date: new Date(),
        compliance_status: "NON_COMPLIED",
        work_status: "",
        remarks: "",
        non_compliance_reason: "",
        event_not_occured: false,
        document_ids: [],
      });
    }
  };

  const [selectedLegalDueDate, setSelectedLegalDueDate] = useState("");
  const handleUpdateTask1 = () => {
    // setShowUpdatePopup(true);
    if (getValue(selectedIDs, `length`, 0) === 1) {
      let findOne =
        getValue(list, `length`, 0) > 0
          ? list.filter(
              (item) =>
                getValue(item, `id`, "") === getValue(selectedIDs, `[${0}]`, "")
            )
          : [];

      setSelectedObj(getValue(findOne, `[${0}]`, {}));
      // if (getValue(findOne, `length`, 0) > 0) {
      setSelfCompliance({
        ...selfCompliance,
        completion_date: getValue(findOne, `[${0}].completion_date`, null)
          ? NewDate(getValue(findOne, `[${0}].completion_date`, null))
          : new Date(),
        compliance_status: getValue(findOne, `[${0}].compliance_status`, null),
        work_status: getValue(findOne, `[${0}].work_status`, null),
        remarks: getValue(findOne, `[${0}].remarks`, null),
        non_compliance_reason: getValue(
          findOne,
          `[${0}].non_compliance_reason`,
          null
        ),
        event_not_occured: getValue(findOne, `[${0}].event_not_occured`, false),
        document_ids: getValue(findOne, `[${0}].documents`, []),
        evaluator_comments: getValue(
          findOne,
          `[${0}].evaluator_comments`,
          null
        ),
      });
      setSelectedLegalDueDate(getValue(findOne, `[${0}].legal_due_date`, null));
      setUpdateId(getValue(findOne, `[${0}].self_compliance.id`, null));
      // }
    } else {
      setSelfCompliance({
        ...selfCompliance,
        completion_date: new Date(),
        compliance_status: "NON_COMPLIED",
        work_status: "",
        remarks: "",
        non_compliance_reason: "",
        event_not_occured: false,
        document_ids: [],
      });
    }
  };

  const handleCancel = () => {
    setShowUpdatePopup(false);
    // setSelectedIDs([]);
  };
  /* -------------------------------------------------------------------------- */
  /*                                 Update Popup                               */
  /* -------------------------------------------------------------------------- */

  const [selfCompliance, setSelfCompliance] = useState<any>({
    status: "",
    remark: "",
    document_ids: [],
  });
  const [updateId, setUpdateId] = useState("");

  const [complianceStatusList] = useState([
    { value: "ASSIGNED", label: "Assigned" },
    { value: "POSING", label: "Posing" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "DELAYED", label: "Delayed" },
    { value: "DELAYED_REPORTED", label: "Delay Reported" },
    { value: "RE_OPENED", label: "Re Opened" },
    { value: "EVENT_NOT_OCCURED", label: "Event Not Occured" },
    { value: "AWAITING_APPROVAL", label: "Awaiting Approval" },
  ]);

  const fileTypes = ["PDF", "JPEG", "XLSX", "CSV", "XLSM", "XLX", "JPG", "PNG"];
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const handleSubmitTask = async (status: string) => {
    setSelectedStatus(status);
    let obj = JSON.parse(JSON.stringify(selfCompliance));
    obj["compliance_status"] = status;
    obj["document_ids"] =
      getValue(selfCompliance, `document_ids.length`, 0) > 0
        ? getValue(selfCompliance, `document_ids`, []).map((item: object) => ({
            id: getValue(item, `id`, ""),
          }))
        : [];

    if (getValue(selfCompliance, `completion_date`, "")) {
      try {
        if (
          (getValue(selectedObj, `self_compliance.document_required`, false)
            ? getValue(selfCompliance, `document_ids.length`, 0) > 0
              ? false
              : true
            : false) &&
          !getValue(selfCompliance, `event_not_occured`, false)
        ) {
          toast.error("Documents required");
        } else {
          setSubmitLoading(true);
          // let resp = await UpdateSelfComplianceTask(selectedIDs[0], obj);
          let resp;
          if (getValue(selectedIDs, `length`, 0) > 1) {
            obj["self_compliance_task_ids"] = selectedIDs;
            resp = await UpdateMultipleSelfComplianceTask(obj);
          } else {
            resp = await UpdateSelfComplianceTask(selectedIDs[0], obj);
          }
          if (resp) {
            toast.success(getValue(resp, `message`, ""));
            setSubmitLoading(false);
            setShowUpdatePopup(false);
            setSelectedIDs([]);
            setSelfCompliance({
              ...selfCompliance,
              status: "",
              remark: "",
              document_ids: [],
            });
            setUpdateId("");
            setSelectedLegalDueDate("");
            setSelectedStatus("");
            getData();
          } else {
            setSubmitLoading(false);
            setSelectedStatus("");
          }
        }
      } catch (error) {
        setSubmitLoading(false);
        setSelectedStatus("");
      }
    } else {
      toast.error("Completion date is mandatory");
    }
  };

  /* -------------------------  Upload Document  ------------------------------ */

  const removeDocument = (id: string) => {
    // let filtered =
    //   getValue(selfCompliance, `document_ids.length`, 0) > 0
    //     ? getValue(selfCompliance, `document_ids`, []).filter(
    //         (item: any) => item.id !== id
    //       )
    //     : [];
    // setSelfCompliance({
    //   ...selfCompliance,
    //   document_ids: filtered,
    // });
  };

  
  const [uploadLoading, setUploadLoading] = useState(false);
  const handleUploadDocuments = async (e: any) => {
    // e.preventDefault();
    Array.from(e).forEach(async (item: any, index: number) => {
      let formData = new FormData();
      formData.append("file", item);
      setUploadLoading(true);
      try {
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          await selfCompliance.document_ids.push(getValue(resp, `data`, {}));
          setSelfCompliance({ ...selfCompliance });
          e = null;
        } else {
          e = null;
        }
      } catch (error) {
        e = null;
      }
      setUploadLoading(false);
    });
  };
  const handleDrop = (e: any) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    files.forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        setUploadLoading(true);
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          await selfCompliance.document_ids.push(getValue(resp, `data`, {}));
          setSelfCompliance({ ...selfCompliance });
          e.target.value = null;
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
      }
      setUploadLoading(false);
    });
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const disableUpload = () => {};

  useEffect(() => {
    if (getValue(selectedIDs, `length`, 0) === 1) {
      handleUpdateTask1();
    }
  }, [selectedIDs]);

  const getUserPermission = (permission: string, data: any) => {
    switch (permission) {
      case "my-task":
        return getValue(data, `executor.id`, "") ===
          getValue(userInfo, `id`, "")
          ? true
          : false;
      case "pending-approval":
        return getValue(data, `evaluator.id`, "") ===
          getValue(userInfo, `id`, "")
          ? true
          : false;

      case "function_head":
        return getValue(data, `function_head.id`, "") ===
          getValue(userInfo, `id`, "")
          ? true
          : false;
      default:
        return true;
    }
  };
  return (
    <div className="master-inner-details-grey-bg">
      <Layout>
        {getValue(params, `request_from`, "") !== "MASTER" &&
        !isLoading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          getSpecificPermissions(route[3])
        ) ? (
          <NoAccessPage />
        ) : (
          <>
            {isLoading || !props.permissionAPITriggered ? (
              <Loader />
            ) : !getUserPermission(route[3], data) ? (
              <NoAccessPage />
            ) : (
              <div className="master-details-page-main">
                <LegacyTaskNavigation
                  id={mainParams.id}
                  lexcare_task_id={mainParams.lexcare_task_id}
                  permissions={props.permissions}
                  global_route={route[1]}
                  parent_route={route[2]}
                  main_route={route[3]}
                  //search
                  isTaskHistorySearch={true}
                  isSearch={true}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  handleClickPopup={handleClickPopup}

                    params={mainParams}
                    status={
                      getValue(data, `approval_status`, "") === "APPROVED"
                        ? getValue(data, `approval_status`, "")
                        : getValue(data, `compliance_status`, "")
                    }
                />
                {getValue(selectedIDs, `length`, 0) > 0 && (
                  <NavigationBar
                    selectedIDs={selectedIDs}
                    text={"MARK INACTIVE"}
                    permissions={props.permissions}
                    licenseIDs={licenseIDs}
                    // assignTask
                    masterNav={"false"}
                    isUpdateTaskVisible={
                      false
                      // getValue(selectedIDs, `length`, 0) === 1 ? true : false
                    }
                    showUpdatePopup={handleUpdateTask}
                  />
                )}
                <div className="main-page-layout-wrapper">
                  <div className="admin-wrapper position-relative">
                    <div className="admin-wrapper position-relative">
                      {/* <SearchHeader
                      route={"/configuration/vendors/add"}
                      searchInput={search_text}
                      showSearchTextbox={showSearchTextbox}
                      toggleSearch={toggleSearch}
                      toggleSearchClose={toggleSearchClose}
                      handleChangeSearch={handleChangeSearch}
                      isBulkUploadVisible={false}
                      smartFilter={false}
                      setFilterFormVisibility={() => {
                        setFilterVisibility(!isFilterVisible);
                      }}
                      isFilterVisible={isFilterVisible}
                      add="false"
                    /> */}
                    </div>

                    {isLoading || !props.permissionAPITriggered ? (
                      <Loader />
                    ) : list.length > 0 ? (
                      <ScrollableDataTable
                        columns={columns}
                        data={list}
                        getTableState={getTableState}
                        rowClick={rowClick}
                        check={true}
                        selectedIDs={selectedIDs}
                        getTrProps={getTrProps}
                      />
                    ) : (
                      <>
                        {Object.keys(params).length !== 0 ? (
                          <>
                            <MappedCheckpointMasterTaskHistoryNotfound />
                          </>
                        ) : (
                          <MappedCheckpointMasterTaskHistoryNotfound />
                        )}
                      </>
                    )}
                  </div>
                  <div className="footer-wrapper d-flex justify-content-between">
                    {list.length > 0 && (
                      <img
                        src="/images/building-illustration.svg"
                        className="img-fluid"
                      />
                    )}
                    {totalCount > 10 ? (
                      <PaginationPage
                        totalCount={totalCount}
                        limit={limit}
                        pageNumber={page_no}
                        handleChangePagination={handleChangePagination}
                        handleChangeLimit={handleChangeLimit}
                      />
                    ) : (
                      <p className="show-rows-count mt-3 d-flex">
                        Total Count:&nbsp;&nbsp;{" "}
                        <p style={{ color: "rgb(13, 110, 253)" }}>
                          {totalCount}
                        </p>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {/* complete task popup */}
        
        {/* <SelfComplianceUpdatePopup
          showUpdatePopup={showUpdatePopup}
          setShowUpdatePopup={handleCancel}
          selfCompliance={selfCompliance}
          setSelfCompliance={setSelfCompliance}
          handleUploadDocuments={handleUploadDocuments}
          handleSubmitTask={handleSubmitTask}
          submitLoading={submitLoading}
          complianceStatusList={complianceStatusList}
          // permissions={getValue(props, `permissions`, [])}
          permissions={["update", "create"]}
          selectedStatus={selectedStatus}
          selectedObj={selectedObj}
          removeDocument={removeDocument}
          handleDrop={handleDrop}
          uploadLoading={uploadLoading}
          handleDragOver={handleDragOver}
          disableUpload={disableUpload}
          selectedLegalDueDate={selectedLegalDueDate}
          selectedIDs={selectedIDs}
        /> */}

          <LegacyTaskEditTask
            showUpdatePopup={showUpdatePopup}
            setShowUpdatePopup={setShowUpdatePopup}
            setSelfCompliance={setSelfCompliance}
            selfCompliance={selfCompliance}
            handleUploadDocuments={handleUploadDocuments}
            handleSubmitTask={handleSubmitTask}
            submitLoading={submitLoading}
            complianceStatusList={complianceStatusList}
            parent_route={route[1]}
            main_route={route[3]}
            sub_route={route[3]}
            removeDocument={removeDocument}
            selectedStatus={selectedStatus}
            selectedObj={data}
            uploadLoading={uploadLoading}
            handleDrop={handleDrop}
            handleDragOver={handleDragOver}
            disableUpload={disableUpload}
            permissions={getValue(props, `permissions`, [])}
            inside={true}
            params={params}
          />
      </Layout>
    </div>
  );
}
